import adverts from '../modules/adverts';

adverts.loadLytics();
